import React, { useEffect, useState } from 'react'
import { service } from '../../../../_services/conversation.service'
import NotificationSettingsModal from '../../Components/NotificationSettingsModal'

export default function NotificationSettings({ shouldNotifyProp, conversationId }) {
  const [show, setShow] = useState(false)
  const [error, setError] = useState('')
  const [shouldNotify, setShouldNotify] = useState(shouldNotifyProp)

  useEffect(() => {
    setShouldNotify(shouldNotifyProp)
  }, [shouldNotifyProp])

  const handleSetShouldNotify = () => {
    const updatedShouldNotify = !shouldNotify
    service.setShouldReceiveNotification(conversationId, updatedShouldNotify)
      .then(() => {
        setShouldNotify(updatedShouldNotify)
      })
      .catch((error) => {
        setShouldNotify(shouldNotify)
        setError(
          error.response.status === 409 ?
            `At least one participant must have notifications enabled per conversation. 
            If you would like to stop receiving notifications, please add another participant to this conversation first.`
            :
            'Could not update notification preference at this time. Please try again.'
        )
      })
  }

  return (
    <div>
      <NotificationSettingsModal
        show={show}
        notify={shouldNotify}
        notifyError={error}
        handleClose={() => { setShow(false); setError('') }}
        handleSetNotify={handleSetShouldNotify}
      />

      <div
        id='notification-settings'
        onClick={() => setShow(true)}
        className='cursor-pointer d-inline-flex pr-3 pt-3'
      >
        <div className='mb-1'>
          <i className="fas fa-bell fa-xs pr-2" />
        </div>
        <div>Notification Settings</div>
      </div>
    </div>
  )
}
